import SellerAnalytics from "./Page/Analytics/AnalyticsView";
import { AnalyticsNavigation } from "./Component/analytics/tracking";
import ProductWarehouse from "./Page/Manage/ProductWarehouse/ProductWarehouse";
import { useAdminThemeScope } from "./styles/useTheme";
import usePreventPinchZoom from "./Component/UI/usePreventPinchZoom";
import usePortraitBrowserLayout from "./Component/UI/usePortraitBrowserLayout";
import { initializeAppearance } from "./Component/UI/useAppearance";
import { StatePage } from "./Component/UI/ContentState";
import BroadcastAppDownload from "./Page/Manage/LiveList/BroadcastAppDownload";
import BroadcastLiveList from "./Page/Broadcast/BroadcastLiveList";
import BroadcastLogin from "./Page/Broadcast/BroadcastLogin";
import BroadcastStudio from "./Page/Broadcast/BroadcastStudio";
import { Navigate, Route, Routes } from "react-router-dom";
import { useEffect, useLayoutEffect, useState } from "react";
import AuthCallback from "./Component/AuthCallback";
import AwakeExchange from "./Component/AwakeExchange";
import AwakeSignup from "./Page/User/Sign/AwakeSignup";
import AwakeHandoff from "./Page/User/Sign/AwakeHandoff";
import Home from "./Page/User/Home/Home";

import SearchStore from "./Page/User/Home/SearchStore";

import SellerProfile from "./Page/User/Home/SellerProfile";
import MyInfo from "./Page/User/Home/MyInfo";
import OrderHistory from "./Page/User/Home/OrderHistory";
import NotificationSettingsPage from "./Page/User/Home/NotificationSettingsPage";
import Help from "./Page/User/Help/Help";

import StoreInquiry from "./Page/User/Home/StoreInquiry";

import SupportChatPage from "./Page/User/Help/SupportChatPage";
import SellerSupportList from "./Page/User/Help/SellerSupportList";
import SignUp from "./Page/User/Sign/SignUp";

import Live from "./Page/User/Live/Live";

import AdminLogin from "./Page/Manage/AdminLogin/AdminLogin";
import AdminFindAccount from "./Page/Manage/AdminLogin/AdminFindAccount";
import Dashborad from "./Page/Manage/Dashboard/Dashborad";

import AdminSign from "./Page/Manage/AdminSign/AdminSign";

import AdminSignUp from "./Page/Manage/AdminSign/AdminSignUp";

import Livelist from "./Page/Manage/LiveList/ManageLivelist";

import LiveMake from "./Page/Manage/LiveList/LiveMake";

import AdminRoute from "./Component/Route/AdminRoute";

import LiveDetail from "./Page/Manage/LiveList/LiveDetail";
import { LiveStatsPopupPage } from './Page/Manage/LiveList/Component/LiveRealtimeStats';
import Orderlist from "./Page/Manage/OrderList/Orderlist";
import OrderLiveList from "./Page/Manage/OrderList/OrderLiveList";
import LiveSales from "./Page/Manage/Sales/LiveSales";
import Userlist from "./Page/Manage/UserList/Userlist";
import Setting from "./Page/Manage/Setting/Setting";

import CoinManage from "./Page/Manage/CoinManage/CoinManage";

import Live_Manage from "./Page/Manage/LiveManage/Live_Manage";

import User_Bill from "./Page/User/Bill/User_Bill";
import PaymentReviewLogin from "./Page/User/Bill/PaymentReviewLogin";
import PaymentReviewLive from "./Page/User/Bill/PaymentReviewLive";
import PaymentReviewSeller from "./Page/User/Bill/PaymentReviewSeller";
import AdminPaymentCancel from "./Page/User/Bill/AdminPaymentCancel";
import Rule from "./Component/UI/Rule";

import TutoLive from "./Page/User/TutoLive/TutoLive";

import CustomerBoard from "./Page/Manage/CustomerBoard/CustomerBoard";
import SellerStaffAccounts from "./Page/Manage/Staff/SellerStaffAccounts";
import PlatformAdmin from "./Page/PlatformAdmin/PlatformAdmin";
import IntegrationTestsPage from "./Page/PlatformAdmin/IntegrationTestsPage";


function App() {
  usePreventPinchZoom();
  usePortraitBrowserLayout();
  useAdminThemeScope();
  useLayoutEffect(() => initializeAppearance(), []);


  const [isView] = useState(true);



  useEffect(() => {

    // 앱 전체를 카카오 인앱 브라우저라는 이유로 차단하지 않는다.
    // 라이브 진입 시 외부 브라우저 연결은 Live 컴포넌트에서 처리한다.
    // 로그인 콜백은 아래 인증 라우팅에서 먼저 처리한다.
    const meta = document.createElement("meta");

    meta.name = "google";

    meta.content = "notranslate";

    document.getElementsByTagName("head")[0].appendChild(meta);

  }, []);



  const authQuery = new URLSearchParams(window.location.search);
  if (window.location.pathname === '/auth/kakao') return <AwakeExchange provider="kakao" />;
  if (window.location.pathname === '/auth/awake' || authQuery.has('accountToken') || (authQuery.has('ssoToken') && !authQuery.has('refreshToken'))) return <AwakeExchange />;
  if (authQuery.has("refreshToken")) return <AuthCallback />;


  return !isView ? (

    <div>test</div>

  ) : (

    <>
    <AnalyticsNavigation />
    <Routes>

      <Route path="/" element={<Home />} />

      <Route path="/search" element={<SearchStore />} />

      <Route path="/store/:seq" element={<SellerProfile />} />
      <Route path="/my-info" element={<MyInfo />} />
      <Route path="/orders" element={<OrderHistory />} />
      <Route path="/my-notifications" element={<NotificationSettingsPage />} />
      <Route path="/broadcast/lives" element={<BroadcastLiveList />} />
      <Route path="/broadcast/login" element={<BroadcastLogin />} />
      <Route path="/broadcast/studio/:seq" element={<BroadcastStudio />} />
      <Route path="/store/:seq/inquiry" element={<StoreInquiry />} />
      <Route path="/store/:seq/inquiry/write" element={<StoreInquiry />} />
      <Route path="/store/:seq/inquiry/detail/:inquirySeq" element={<StoreInquiry />} />
      <Route path="/help" element={<Help />} />
      <Route path="/support/platform" element={<SupportChatPage channel="platform" />} />
      <Route path="/support/sellers" element={<SellerSupportList />} />
      <Route path="/support/conversations/:conversationSeq" element={<SupportChatPage />} />
      <Route path="/rule/:type" element={<Rule />} />

      <Route path="/rule-seller/:type" element={<Rule seller />} />

      <Route path="/signup" element={authQuery.get('awake') === '1' ? <AwakeSignup /> : authQuery.get('kakao') === '1' ? <AwakeSignup provider="kakao" /> : <SignUp />} />
      <Route path="/awake-handoff" element={<AwakeHandoff />} />
      <Route path="/live/:seq" element={<Live />} />

      <Route path="/bill/:uid" element={<User_Bill />} />

      <Route path="/payment-review/:orderSeq" element={<PaymentReviewLogin />} />
      <Route path="/payment-review/store/:seq" element={<PaymentReviewSeller />} />
      <Route path="/payment-review/live/:seq" element={<PaymentReviewLive />} />
      <Route path="/tutorial" element={<TutoLive />} />



      <Route path="/integration-tests" element={<IntegrationTestsPage />} />
      <Route path="/admin_main/*" element={<PlatformAdmin />} />

      {/* 관리자 페이지 */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/find-account" element={<AdminFindAccount />} />
      <Route path="/admin/adminsign" element={<AdminSign />} />

      <Route path="/admin/adminsignup" element={<AdminSignUp />} />

      <Route path="admin">
        <Route path="products" element={<AdminRoute component={ProductWarehouse} allowedLevels={["master"]} />} />
        <Route path="broadcast-app" element={<AdminRoute component={BroadcastAppDownload} allowedLevels={["master", "cs"]} requiredPermissions={["menu_live"]} />} />
        <Route index element={<Navigate to="/admin/login" replace />} />
        <Route path="payment-cancel" element={<AdminRoute component={AdminPaymentCancel} component_m={AdminPaymentCancel} allowedLevels={["linkcam"]} />} />
        <Route

          path="dashboard"

          element={<AdminRoute component={Dashborad} allowedLevels={["master"]} />}
        />

        <Route

          path="livelist"

          element={

            <AdminRoute component={Livelist} allowedLevels={["master", "cs"]} requiredPermissions={["menu_live"]} />
          }

        />

        <Route

          path="livelist/Live_manage/:seq"

          element={

            <AdminRoute component={Live_Manage} component_m={Live_Manage} allowedLevels={["master", "cs"]} requiredPermissions={["menu_live", "live_run"]} permissionMode="all" />
          }

        />

        <Route

          path="livelist/:seq"

          element={<AdminRoute component={LiveDetail} allowedLevels={["master", "cs"]} requiredPermissions={["menu_live"]} />}
        />

        <Route path="livelist/:seq/stats"
          element={<AdminRoute component={LiveStatsPopupPage} allowedLevels={["master"]} requiredPermissions={["menu_live"]} />} />

        <Route

          path="livelist/make"

          element={<AdminRoute component={LiveMake} allowedLevels={["master", "cs"]} requiredPermissions={["menu_live", "live_manage"]} permissionMode="all" />}
        />

        <Route
          path="order-list"
          element={<AdminRoute component={OrderLiveList} allowedLevels={["master", "cs"]} requiredPermissions={["menu_orders"]} />}
        />
        <Route path="analytics" element={<AdminRoute component={SellerAnalytics} allowedLevels={["master", "cs"]} requiredPermissions={["menu_analytics"]} />} />
        <Route path="live-sales" element={<AdminRoute component={LiveSales} allowedLevels={["master"]} />} />
        <Route
          path="orderlist/:page"

          element={<AdminRoute component={Orderlist} allowedLevels={["master", "cs"]} requiredPermissions={["menu_orders"]} />}
        />

        <Route

          path="userlist/:page"

          element={<AdminRoute component={Userlist} allowedLevels={["master", "cs"]} requiredPermissions={["menu_members"]} />}
        />

        <Route

          path="coinmanage"

          element={<AdminRoute component={CoinManage} allowedLevels={["master", "cs"]} requiredPermissions={["menu_coin"]} />}
        />

        <Route

          path="customer-board"

            element={<AdminRoute component={CustomerBoard} component_m={CustomerBoard} allowedLevels={["master", "cs"]} requiredPermissions={["menu_inquiry"]} />}
        />

        <Route path="staff" element={<AdminRoute component={SellerStaffAccounts} allowedLevels={["master", "cs"]} requiredPermissions={["account_manage", "account_permission"]} />} />
        <Route path="setting" element={<AdminRoute component={Setting} allowedLevels={["master", "cs"]} requiredPermissions={["menu_settings"]} />} />
      </Route>

      <Route path="*" element={<StatePage label="팬버드" icon="search" title="페이지를 찾을 수 없어요" description="주소가 변경되었거나 사용할 수 없는 페이지예요.
홈에서 원하는 라이브와 스토어를 찾아보세요." action={{ label: "홈으로", href: "/" }} secondaryAction={{ label: "스토어 찾기", href: "/search" }} />} />
    </Routes>
    </>

  );

}



export default App;
